import { z } from 'zod'
import { ApiLocale } from '@library/enums'
import { areaSchema } from './area'
import { countrySchema } from './country'
import { citySchema } from './city'

/** 區域、國家與城市 對應資料 Schema */
export const areaCountryCitySchema = z.object({
  /** 語系 */
  lang: z.enum(ApiLocale),
  /** 區域列表 */
  area: z.array(areaSchema),
  /** 國家列表 */
  country: z.array(countrySchema),
  /** 航點列表 */
  city: z.array(citySchema)
})

/** 區域、國家與航點 對應資料 */
export interface AreaCountryCity extends z.infer<
  typeof areaCountryCitySchema
> {}
